/* ============================================================
   Community Bio+ — Dawn interactions (vanilla, no deps).
   Boots once, re-enhances on shopify:section:load so the Theme
   Editor stays live. Overlay UI (recipe modal, lightbox, toasts)
   is built on demand inside a single .cb-overlays host; the apply /
   deck dialogs are server-rendered in Liquid (native contact forms).

   DO NOT AJAX THE CONTACT FORMS. Shopify's spam protection owns them:
   its shim intercepts the submit, fetches a captcha token, then calls
   form.submit() programmatically — firing no submit event, so no listener
   can cancel it. A hand-rolled fetch POST to /contact carries no token,
   gets rejected, and the visitor is thrown out to a bare hCaptcha page.
   (sections/ba-signup-toast.liquid carries the same warning; it was
   learned there first and ignored here once already.)

   Instead the post is native and the round trip is made invisible:
     1. the scroll position + dialog key go into sessionStorage on submit
     2. on the way back (?cb_posted=<id>) the position is restored before
        the top of the page paints, then re-checked on DOMContentLoaded
        and load, since late images move things down
     3. the success toast fires once the page has settled
   ============================================================ */
(function () {
  'use strict';

  var SVG = {
    close: '<svg aria-hidden="true" focusable="false" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M18 6 6 18M6 6l12 12"/></svg>',
    check: '<svg aria-hidden="true" focusable="false" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M20 6 9 17l-5-5"/></svg>',
    alert: '<svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5"/><path d="M12 16.5h.01"/></svg>',
    heart: '<svg aria-hidden="true" focusable="false" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M12 21s-7.5-4.6-10-9.3C.7 9 1.6 5.6 4.6 4.7 7 4 9 5.2 12 8c3-2.8 5-4 7.4-3.3 3 .9 3.9 4.3 2.6 7C19.5 16.4 12 21 12 21z"/></svg>',
    comment: '<svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 9 9 0 0 1-3.6-.7L3 21l1.3-3.6A8.4 8.4 0 1 1 21 11.5z"/></svg>'
  };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CB_KEY = 'cb:dialog:return';
  function esc(t){ return (t==null?'':String(t)).replace(/[&<>"]/g, function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function fmtK(n){ return n>=1000 ? (n/1000).toFixed(1).replace(/\.0$/,'')+'k' : ''+n; }

  /* ---- dialog form validation ----
     Fields carry data-check (name|email|tel|free|text), data-label and a
     [data-field-err] slot (see snippets/community-dialog.liquid).
     blur judges a field, input re-checks one already flagged, submit gates
     the lot. No TLD is enforced anywhere. */
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/;
  var TEL_SHAPE_RE = /^\+?[0-9\s().-]{7,24}$/;
  var MASH_RE = /(asdf|sdfg|dfgh|fghj|ghjk|hjkl|qwer|wert|erty|rtyu|tyui|zxcv|xcvb|cvbn|vbnm|1234|abcd)/i;
  var NOT_A_NAME = 'That doesn\u2019t look like a name \u2014 please use the name we should call you.';
  function fieldWrap(el){ return el.closest ? el.closest('.field') : null; }
  function labelOf(el){ return el.getAttribute('data-label') || 'This field'; }
  function setFieldErr(el, msg){
    var f = fieldWrap(el), slot = f && f.querySelector('[data-field-err]');
    el.setAttribute('aria-invalid','true');
    if(f){ f.classList.add('has-err'); f.classList.remove('is-ok'); }
    if(slot){ slot.textContent = msg; slot.hidden = false; }
  }
  function clearFieldErr(el, markOk){
    var f = fieldWrap(el), slot = f && f.querySelector('[data-field-err]');
    el.removeAttribute('aria-invalid');
    if(f){ f.classList.remove('has-err'); if(markOk && el.value.trim()) f.classList.add('is-ok'); else f.classList.remove('is-ok'); }
    if(slot){ slot.textContent = ''; slot.hidden = true; }
  }
  function messageFor(el, v){
    var kind = el.getAttribute('data-check') || 'text';
    if(!v) return el.required ? labelOf(el) + ' is required.' : '';
    if(kind === 'free') return '';
    if(kind === 'email') return EMAIL_RE.test(v) ? '' : 'That email address doesn\u2019t look right \u2014 check it for typos.';
    if(kind === 'name'){
      if(v.length < 2 || !/[A-Za-z\u0600-\u06FF]/.test(v)) return 'Please enter your full name.';
      var latinOnly = /^[A-Za-z\s'.\-]+$/.test(v);
      if(latinOnly && v.length >= 4){
        if(!/[aeiouy]/i.test(v)) return NOT_A_NAME;
        if(/(.)\1{2,}/.test(v)) return NOT_A_NAME;
        if(MASH_RE.test(v)) return NOT_A_NAME;
      }
      return '';
    }
    if(kind === 'tel'){
      var digits = v.replace(/[^0-9]/g, '');
      var ok = TEL_SHAPE_RE.test(v) && digits.length >= 7 && digits.length <= 15;
      return ok ? '' : 'Enter a number we can reach you on \u2014 e.g. 050 123 4567.';
    }
    return v.length >= 2 ? '' : 'Please give us a little more detail here.';
  }
  function checkField(el, commit){
    var v = el.value.trim();
    if(commit) el.value = v;
    return messageFor(el, v);
  }
  function validateDialogForm(form){
    var firstBad = null, badCount = 0;
    Array.prototype.forEach.call(form.querySelectorAll('input[data-check]'), function(el){
      var msg = checkField(el, true);
      if(msg){ setFieldErr(el, msg); badCount++; if(!firstBad) firstBad = el; }
      else clearFieldErr(el, true);
    });
    var summary = form.querySelector('[data-err]');
    if(summary){
      if(firstBad){ summary.textContent = badCount === 1 ? 'One field needs fixing before we can send this.' : 'Please fix the ' + badCount + ' highlighted fields and try again.'; summary.style.display = 'block'; }
      else { summary.textContent = ''; summary.style.display = 'none'; }
    }
    if(firstBad){
      try { firstBad.focus({ preventScroll: true }); } catch(e){ firstBad.focus(); }
      try { firstBad.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' }); } catch(e){}
      var dlg = firstBad.closest('[data-cb-dialog]');
      var short = badCount === 1 ? 'One field needs fixing.' : badCount + ' fields need fixing.';
      try { toast((dlg && dlg.dataset.cbFailure) || short, 'error'); } catch(e){}
      return false;
    }
    return true;
  }
  function bindLiveChecks(form){
    form.addEventListener('focusout', function(e){
      var el = e.target;
      if(!el || !el.hasAttribute || !el.hasAttribute('data-check')) return;
      var msg = checkField(el, true);
      if(msg) setFieldErr(el, msg); else clearFieldErr(el, true);
    });
    form.addEventListener('input', function(e){
      var el = e.target;
      if(!el || !el.hasAttribute || !el.hasAttribute('data-check')) return;
      if(el.getAttribute('aria-invalid') !== 'true') return;
      var msg = checkField(el, false);
      if(!msg) clearFieldErr(el, true); else setFieldErr(el, msg);
    });
  }

  /* ---- keeping the native round trip invisible ---- */
  function jump(y){
    /* the theme scrolls smoothly by default; a smooth scrollTo on a fresh load
       animates up from the top and looks like an anchor jump. Inline wins. */
    var els = [document.documentElement, document.body], prev = [];
    els.forEach(function(el, i){ if(!el) return; prev[i] = el.style.scrollBehavior; el.style.scrollBehavior = 'auto'; });
    window.scrollTo(0, y);
    els.forEach(function(el, i){ if(!el) return; el.style.scrollBehavior = prev[i] || ''; });
  }
  function rememberSpot(key){
    try { sessionStorage.setItem(CB_KEY, JSON.stringify({ id: key, y: window.pageYOffset || 0, t: Date.now() })); } catch(e){}
  }
  function readSpot(){
    try {
      var raw = sessionStorage.getItem(CB_KEY);
      var st = raw ? JSON.parse(raw) : null;
      if(st && (Date.now() - st.t) < 120000) return st;
    } catch(e){}
    return null;
  }
  function forgetSpot(){ try { sessionStorage.removeItem(CB_KEY); } catch(e){} }

  /* ---- shared overlay host + toasts ---- */
  function host() {
    var page = document.querySelector('.cb-page'); if(!page) return null;
    var h = document.querySelector('.cb-overlays');
    if (!h) { h = document.createElement('div'); h.className='cb-page cb-overlays'; document.body.appendChild(h); }
    return h;
  }
  function toast(msg, kind) {
    var h = host(); if(!h) return;
    var isErr = kind === 'error';
    msg = String(msg == null ? '' : msg).replace(/\s+/g, ' ').trim();
    if(msg.length > 90) msg = msg.slice(0, 87).replace(/[\s,.;:\u2014-]+$/, '') + '\u2026';
    var wrap = h.querySelector('.toast-wrap');
    if(!wrap){ wrap=document.createElement('div'); wrap.className='toast-wrap'; wrap.setAttribute('role','status'); wrap.setAttribute('aria-live','polite'); h.appendChild(wrap); }
    wrap.setAttribute('aria-live', isErr ? 'assertive' : 'polite');
    var t=document.createElement('div'); t.className = isErr ? 'toast toast--err' : 'toast';
    var icon = isErr ? SVG.alert : SVG.check.replace('width="30" height="30"','width="16" height="16"');
    t.innerHTML='<span class="tk">'+icon+'</span>'+esc(msg);
    wrap.appendChild(t);
    setTimeout(function(){ t.style.opacity='0'; t.style.transform='translateY(10px)'; setTimeout(function(){t.remove();},300); }, isErr ? 5200 : 3200);
  }
  function lockScroll(on){ document.body.style.overflow = on ? 'hidden' : ''; }

  /* ---- smooth scroll ---- */
  function scrollTo(sel){
    var el = document.querySelector(sel); if(!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - 70;
    window.scrollTo({ top:y, behavior: reduceMotion ? 'auto' : 'smooth' });
  }

  /* ---- focus helpers ---- */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([type=hidden]), select, textarea, [tabindex]:not([tabindex="-1"])';
  function trapTab(container){
    if(container.__trap) return; container.__trap = 1;
    container.addEventListener('keydown', function(e){
      if(e.key !== 'Tab') return;
      var f = container.querySelectorAll(FOCUSABLE);
      if(!f.length) return;
      var first = f[0], last = f[f.length-1];
      if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    });
  }

  /* ---- Liquid-rendered dialogs (apply / wholesale deck) ---- */
  function openDialog(key, opener){
    var dlg = document.querySelector('[data-cb-dialog="'+key+'"]'); if(!dlg) return;
    if(dlg.classList.contains('cb-dialog--inline')) return; /* inline forms are always on show */
    dlg.hidden = false;
    dlg.__opener = opener || document.activeElement;
    var stepForm = dlg.querySelector('[data-cb-step="form"]');
    var stepDone = dlg.querySelector('[data-cb-step="done"]');
    if(stepForm) stepForm.hidden = false;
    if(stepDone) stepDone.hidden = true;
    var ov = dlg.querySelector('.overlay'), mo = dlg.querySelector('.modal');
    void dlg.offsetWidth;
    if(ov)ov.classList.add('show'); if(mo)mo.classList.add('show');
    lockScroll(true);
    trapTab(dlg);
    var first = dlg.querySelector('input:not([type=hidden])') || dlg.querySelector('.modal-x');
    setTimeout(function(){ if(first) first.focus(); }, 80);
    dlg.__esc = function(e){ if(e.key==='Escape') closeDialog(dlg); };
    document.addEventListener('keydown', dlg.__esc);
  }
  function closeDialog(dlg){
    var ov = dlg.querySelector('.overlay'), mo = dlg.querySelector('.modal');
    if(ov)ov.classList.remove('show'); if(mo)mo.classList.remove('show');
    lockScroll(false);
    if(dlg.__esc) document.removeEventListener('keydown', dlg.__esc);
    setTimeout(function(){ dlg.hidden = true; }, 300);
    if(dlg.__opener && dlg.__opener.focus) dlg.__opener.focus();
  }

  /* ---- JS-built modal shell (recipe modal) ---- */
  function buildModal(innerHTML, opts){
    opts = opts || {};
    var h = host(); if(!h) return null;
    var opener = document.activeElement;
    var ov = document.createElement('div'); ov.className='overlay';
    var modal = document.createElement('div'); modal.className='modal';
    modal.innerHTML = '<div class="modal-box '+(opts.boxClass||'')+'" role="dialog" aria-modal="true"'+(opts.label?' aria-label="'+esc(opts.label)+'"':'')+'>'+innerHTML+'</div>';
    h.appendChild(ov); h.appendChild(modal);
    function close(){
      ov.classList.remove('show'); modal.classList.remove('show'); lockScroll(false);
      document.removeEventListener('keydown', onEsc);
      setTimeout(function(){ov.remove();modal.remove();},300);
      if(opener && opener.focus) opener.focus();
    }
    function onEsc(e){ if(e.key==='Escape') close(); }
    ov.addEventListener('click', close);
    modal.addEventListener('click', function(e){ if(e.target.closest('[data-cb-close]')) close(); });
    document.addEventListener('keydown', onEsc);
    trapTab(modal);
    void ov.offsetWidth;
    ov.classList.add('show'); modal.classList.add('show'); lockScroll(true);
    var x = modal.querySelector('.modal-x') || modal.querySelector(FOCUSABLE);
    if(x) x.focus();
    return { el: modal, close: close };
  }

  /* ---- recipe modal ---- */
  function openRecipe(card){
    var d = card.dataset;
    var src = card.querySelector('[data-recipe-detail]');
    var detail = src ? src.innerHTML : '';
    var media = d.img
      ? '<img class="img-fill" src="'+esc(d.img)+'" alt="" loading="lazy" decoding="async">'
      : '<div class="ph" style="--ph-a:'+(d.color||'#b8324c')+';--ph-b:'+(d.color||'#b8324c')+'"></div>';
    var metas = (d.time?'<span class="rt">'+esc(d.time)+'</span>':'')+
                (d.serves?'<span class="rt">'+esc(d.serves)+'</span>':'')+
                (d.kicker?'<span class="rt">'+esc(d.kicker)+'</span>':'');
    var html =
      '<div class="recipe-modal-media">'+media+'<div class="recipe-modal-scrim"></div>'+
      '<button class="modal-x recipe-modal-x" type="button" data-cb-close aria-label="Close recipe">'+SVG.close+'</button>'+
      '<div class="recipe-modal-cap"><span class="recipe-phue"><span class="recipe-phue-dot" style="background:'+(d.color||'#b8324c')+'"></span>'+esc(d.hue||'')+'</span><h3>'+esc(d.title)+'</h3></div></div>'+
      '<div class="modal-body"><p class="recipe-modal-desc">'+esc(d.desc||'')+'</p>'+
      '<div class="recipe-modal-meta">'+metas+'</div>'+detail+'</div>';
    buildModal(html, { boxClass:'recipe-modal', label: d.title || 'Recipe' });
  }

  /* ---- instagram lightbox ---- */
  function openLightbox(card){
    var d = card.dataset, h = host(); if(!h) return;
    var opener = document.activeElement;
    var lb = document.createElement('div'); lb.className='lightbox';
    lb.setAttribute('role','dialog'); lb.setAttribute('aria-modal','true'); lb.setAttribute('aria-label','Post '+(d.handle||''));
    var media = d.img ? '<img class="img-fill" src="'+esc(d.img)+'" alt="'+esc(d.sub||d.handle||'')+'">' : '<div class="ph" style="--ph-a:'+(d.a||'#ffd9df')+';--ph-b:'+(d.b||'#b8324c')+'"></div>';
    var likes = parseInt(d.likes||'0',10)+1;
    lb.innerHTML = '<button class="lb-close" type="button" data-cb-close aria-label="Close">'+SVG.close+'</button>'+
      '<div class="lb-card"><div class="lb-media">'+media+(d.tagname?'<span class="insta-tag">'+esc(d.tagname)+'</span>':'')+'</div>'+
      '<div class="lb-body"><div class="ihandle">'+esc(d.handle||'')+'</div><div class="isub">'+esc(d.sub||'')+'</div>'+
      '<div class="insta-likes" style="color:var(--ink);margin-top:14px"><button type="button" class="liked" aria-pressed="true" style="color:var(--berry)">'+SVG.heart+' <span data-like-count>'+fmtK(likes)+'</span> likes</button>'+
      '<span style="display:inline-flex;align-items:center;gap:6px">'+SVG.comment+' Comment</span></div></div></div>';
    h.appendChild(lb);
    function close(){
      lb.classList.remove('show'); lockScroll(false);
      document.removeEventListener('keydown', onEsc);
      setTimeout(function(){lb.remove();},300);
      if(opener && opener.focus) opener.focus();
    }
    function onEsc(e){ if(e.key==='Escape') close(); }
    lb.addEventListener('click', function(e){
      var like = e.target.closest('.insta-likes button');
      if(like){
        var on = like.classList.toggle('liked');
        like.setAttribute('aria-pressed', on ? 'true' : 'false');
        like.style.color = on ? 'var(--berry)' : 'var(--ink)';
        var c = like.querySelector('[data-like-count]');
        if(c) c.textContent = fmtK(parseInt(d.likes||'0',10)+(on?1:0));
        return;
      }
      if(e.target.closest('[data-cb-close]') || e.target===lb) close();
    });
    document.addEventListener('keydown', onEsc);
    trapTab(lb);
    void lb.offsetWidth;
    lb.classList.add('show'); lockScroll(true);
    var x=lb.querySelector('.lb-close'); if(x)x.focus();
  }

  /* ---- count up ---- */
  function countUp(el){
    if(el.__counted) return; el.__counted = 1;
    var end = parseInt(el.dataset.countup,10)||0;
    if(reduceMotion || document.hidden){ el.textContent = end; return; }
    var dur=1400, start=null;
    function tick(t){ if(!start)start=t; var p=Math.min((t-start)/dur,1); var e=1-Math.pow(1-p,3); el.textContent=Math.round(e*end); if(p<1)requestAnimationFrame(tick); }
    requestAnimationFrame(tick);
  }

  /* ---- scroll reveal + countup observer ---- */
  var io;
  function activate(el){
    el.classList.add('in');
    if(el.dataset.countup!=null) countUp(el);
  }
  function observe(el){
    if(!('IntersectionObserver' in window) || document.hidden){ activate(el); return; }
    if(!io){ io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ var t=e.target; io.unobserve(t); if(!t.classList.contains('in')) activate(t); } }); }, { threshold:0.15 }); }
    io.observe(el);
    setTimeout(function(){ if(!el.classList.contains('in')){ io.unobserve(el); activate(el); } }, 1700);
  }

  /* ---- coming back from a native post ---- */
  var cbMoved = false, cbSpot = null;
  function cbPlace(){
    if(cbMoved || !cbSpot) return;
    jump(cbSpot.y);
  }
  function handleReturn(){
    var m = location.search.match(/[?&]cb_posted=([^&]+)/);
    var key = m ? decodeURIComponent(m[1]) : '';
    var srvErr = document.querySelector('[data-cb-dialog] [data-server-err]');
    var hasServerErr = !!(srvErr && (srvErr.textContent || '').trim());
    if(!key && !hasServerErr) return;

    cbSpot = readSpot();
    if(cbSpot){
      if(window.history && 'scrollRestoration' in history) history.scrollRestoration = 'manual';
      cbPlace();                                   /* before the top of the page paints */
      ['wheel','touchstart','keydown','pointerdown'].forEach(function(t){
        window.addEventListener(t, function(){ cbMoved = true; }, { passive:true, once:true });
      });
      document.addEventListener('DOMContentLoaded', cbPlace);
      window.addEventListener('load', cbPlace);
    }

    window.addEventListener('load', function(){
      if(hasServerErr){
        var failDlg = srvErr.closest('[data-cb-dialog]');
        if(failDlg){
          openDialog(failDlg.getAttribute('data-cb-dialog'));
          toast(failDlg.dataset.cbFailure || 'That didn\u2019t go through.', 'error');
        }
      } else if(key){
        var dlg = document.querySelector('[data-cb-dialog="'+key+'"]');
        toast((dlg && dlg.dataset.cbSuccess) || 'Thanks \u2014 we got your message!');
      }
      forgetSpot();
    });

    if(key && window.history && history.replaceState){
      var clean = location.pathname
        + location.search.replace(/([?&])cb_posted=[^&]*&?/, '$1').replace(/[?&]$/, '')
        + location.hash;
      history.replaceState({}, '', clean);
    }
  }

  /* ============================================================
     BOOT — idempotent per element via dataset flags
     ============================================================ */
  function boot(root){
    root = root || document;

    if(!window.__cbReturn){ window.__cbReturn = true; try { handleReturn(); } catch(e){} }

    // smooth-scroll triggers
    root.querySelectorAll('[data-cb-scroll]').forEach(function(b){ if(b.__cb)return; b.__cb=1; b.addEventListener('click', function(e){ e.preventDefault(); scrollTo(b.getAttribute('data-cb-scroll')); }); });

    // reveal + countup
    root.querySelectorAll('.reveal:not(.in), [data-countup]').forEach(observe);

    // insta filter
    root.querySelectorAll('.filter-row').forEach(function(fr){ if(fr.__cb)return; fr.__cb=1;
      fr.addEventListener('click', function(e){ var chip=e.target.closest('.chip'); if(!chip)return;
        fr.querySelectorAll('.chip').forEach(function(c){
          var on = c===chip;
          c.classList.toggle('on', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var tag=chip.dataset.filter;
        var grid=fr.parentElement.querySelector('.insta-row') || fr.parentElement.querySelector('.insta-masonry');
        if(grid) grid.querySelectorAll('.insta-card').forEach(function(card){ card.style.display=(tag==='All'||card.dataset.tag===tag)?'':'none'; });
      });
    });

    // insta lightbox
    root.querySelectorAll('.insta-open').forEach(function(btn){ if(btn.__cb)return; btn.__cb=1;
      btn.addEventListener('click', function(){ var card=btn.closest('.insta-card'); if(card) openLightbox(card); });
    });

    // recipes
    root.querySelectorAll('[data-cb-recipe]').forEach(function(card){ if(card.__cb)return; card.__cb=1;
      card.addEventListener('click', function(){ openRecipe(card); });
    });

    // refer copy / share
    root.querySelectorAll('[data-cb-copy]').forEach(function(b){ if(b.__cb)return; b.__cb=1;
      b.addEventListener('click', function(){ var link=b.dataset.cbCopy;
        var done=function(){ b.classList.add('done'); b.innerHTML='<svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><path d="M20 6 9 17l-5-5"/></svg> Copied'; toast(b.dataset.copiedToast || 'Link copied!'); setTimeout(function(){ b.classList.remove('done'); b.textContent=b.dataset.label||'Copy'; },2200); };
        if(navigator.clipboard&&navigator.clipboard.writeText){ navigator.clipboard.writeText(link).then(done).catch(done); } else done();
      });
    });
    root.querySelectorAll('[data-cb-share]').forEach(function(b){ if(b.__cb)return; b.__cb=1; b.addEventListener('click', function(){ toast('Opening '+b.dataset.cbShare+' to share your link\u2026'); }); });

    // Liquid dialogs (apply / wholesale deck)
    root.querySelectorAll('[data-cb-dialog-open]').forEach(function(b){ if(b.__cb)return; b.__cb=1;
      b.addEventListener('click', function(){ openDialog(b.dataset.cbDialogOpen, b); });
    });
    root.querySelectorAll('[data-cb-dialog]').forEach(function(dlg){ if(dlg.__cb)return; dlg.__cb=1;
      dlg.addEventListener('click', function(e){ if(e.target.closest('[data-cb-dialog-close]')) closeDialog(dlg); });
      var form = dlg.querySelector('form');
      if(form){
        form.setAttribute('novalidate', 'novalidate');
        bindLiveChecks(form);

        form.addEventListener('submit', function(e){
          if(form.__cbSending){ e.preventDefault(); return; }

          var ok = false;
          try { ok = validateDialogForm(form); } catch(err){ ok = false; }
          if(!ok){ e.preventDefault(); return; }

          /* Passed. Remember the spot, then GET OUT OF THE WAY — the post must
             stay native so Shopify's spam shim can attach its captcha token. */
          rememberSpot(dlg.getAttribute('data-cb-dialog'));
          form.__cbSending = true;
          var btn = form.querySelector('button[type=submit]');
          if(btn) btn.classList.add('is-sending');   /* class only — never disabled, that can drop the button from the POST */
          try {
            var detail = {}; Array.prototype.forEach.call(form.elements, function(el){ if(el.name) detail[el.name]=el.value; });
            document.dispatchEvent(new CustomEvent('cb:apply-submitted',{detail:detail}));
          } catch(err){}
        });
      }
    });

    // sticky mobile CTA — appears after the hero, hides at the signup form
    root.querySelectorAll('[data-cb-sticky-cta]').forEach(function(bar){ if(bar.__cb)return; bar.__cb=1;
      if(!('IntersectionObserver' in window) || document.hidden) return;
      bar.hidden = false;
      var hero = document.querySelector('.cb-hero'), signup = document.getElementById('cb-signup');
      if(!hero) return;
      var heroIn = true, signupIn = false;
      function applyBar(){ bar.classList.toggle('on', !heroIn && !signupIn); }
      var sio = new IntersectionObserver(function(es){
        es.forEach(function(e){
          if(e.target === hero) heroIn = e.isIntersecting;
          if(e.target === signup) signupIn = e.isIntersecting;
        });
        applyBar();
      }, { threshold: 0.08 });
      sio.observe(hero);
      if(signup) sio.observe(signup);
    });

    // signup — demo fallback (static preview only)
    root.querySelectorAll('[data-cb-signup]').forEach(function(form){ if(form.__cb)return; form.__cb=1;
      form.addEventListener('submit', function(e){ e.preventDefault();
        var email=(form.querySelector('input[type=email]')||{}).value||''; var err=form.querySelector('[data-err]');
        if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())){ if(err){err.textContent='Pop in a valid email so we can send your reward.'; err.style.display='block';} try { toast('Check your email address.', 'error'); } catch(x){} return; }
        document.dispatchEvent(new CustomEvent('cb:signup',{detail:{email:email}}));
        var wrap=form.closest('.signup-form');
        if(wrap) wrap.innerHTML='<div class="signup-success" role="status"><div class="ss-ring">'+SVG.check+'</div><h4>You\u2019re in! \uD83C\uDF89</h4><p>Check your inbox \u2014 your welcome reward and first recipe drop are on the way. Welcome to the Circle.</p></div>';
      });
    });
  }

  window.__cbBooted = true;
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', function(){ boot(); });
  document.addEventListener('shopify:section:load', function(e){ boot(e.target); });
})();
